<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner
      :background="info.image ? info.image.url : ''"
      :title="!pgLoading ? $t('auth.forget_password') : ''"
      :subtitle="!pgLoading ? $t('auth.forget_password') : ''"
    >
    </Banner>

    <section class="login-area grey-bg2 pt-50">
      <div class="container">
        <div class="row d-flex justify-content-center">
          <div
            class="login-section donation-form white-bg mb-30 wow fadeInUp2 animated"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: fadeInUp2;
            "
          >
            <div
              class="section-title text-left mb-50"
              :style="$i18n.locale == 'en' ? 'text-align: left !important' : ''"
            >
              <div v-if="!pgLoading">
                <h6>
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                    ><i class="fas fa-heart"></i></span
                  >{{ info.title }}
                </h6>
                <p v-html="info.body" class="reset-desc"></p>
              </div>
            </div>

            <div class="row payment-inner">
              <form>
                <div class="row">
                  <div class="col-12">
                    <div class="input-area mb-30">
                      <input
                        type="email"
                        class="form-control"
                        v-model="row.email"
                        :placeholder="$t('auth.enter_email')"
                      />
                    </div>
                  </div>
                  <div class="col-xl-12 mb-4">
                    <button
                      type="button"
                      class="theme_btn theme_btn_bg btn-size"
                      @click="forget()"
                    >
                      <div v-if="btnLoading">
                        <div class="loader loader-xs loader-center"></div>
                      </div>
                      <div v-if="!btnLoading">
                        {{ $t("auth.reset_password") }}
                        <span></span>
                      </div>
                    </button>
                  </div>
                  <div class="col-6 d-flex justify-content-start">
                    <div class="input-area">
                      <h5>
                        <router-link :to="{ name: 'login' }" class="log-in">
                          {{ $t("auth.login") }}
                        </router-link>
                      </h5>
                    </div>
                  </div>
                  <div class="col-6 d-flex justify-content-end">
                    <h5>
                      {{ $t("auth.not_member") }}
                      <router-link :to="{ name: 'register' }">
                        {{ $t("auth.register") }}
                      </router-link>
                    </h5>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import iziToast from "izitoast";

export default {
  name: "forget",
  components: {
    Banner: () => import("@/components/Banner.vue"),
  },
  data() {
    return {
      row: {
        token: "",
        email: "",
        password: "",
        password_confirmation: "",
      },
      locale: "ar",
      btnLoading: false,
      pgLoading: true,
      info: "",
    };
  },
  computed: {},
  created() {
    //

    if (localStorage.getItem("forget_email")) {
      this.row.email = localStorage.getItem("forget_email");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/24",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
        })
        .catch(() => {})
        .finally(() => {});
    },

    // forget
    forget() {
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/auth/password/forget",
        method: "POST",
        data: {
          email: this.row.email,
        },
      };
      this.$axios(options)
        .then(() => {
          this.btnLoading = false;

          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.email_msg"),
          });

          localStorage.setItem("forget_email", this.row.email);
          this.$router.push({ name: "reset" });
        })
        .catch(() => {
          this.btnLoading = false;
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: this.$t("app.email_msg_failed"),
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-size {
  cursor: pointer;
  width: 232px;
  height: 52px;
}
</style>
